import { APP_SIGN_IN_URL } from "../../../utils";

export const ZORBI_PRO_BENEFIT_LIST = [
  "Image Annotation/Occlusion",
  "Text-To-Speech (24+ languages)",
  "5x Learning Profiles",
  "More Customization ",
  "Increased Upload Limits",
  "Priority Support",
  "... and a lot more coming soon.",
];

export enum PricingMode {
  Monthly,
  Annual,
  Lifetime,
}

export enum PricingTier {
  Free,
  Pro,
  School,
}

export interface PriceData {
  label: string;
  price: number | string;
  cadence: string;
  subtitle?: string;
  link: string;
}

interface TierData {
  label: string;
  text: string;
  tier: PricingTier;
  ctaText: string;
  featured?: boolean;
}

export type PricingTierData = TierData &
  Partial<Record<PricingMode, PriceData>>;

type PricingModeData = Record<PricingMode, PriceData>;

const monthlyPricingData = {
  label: "Monthly",
  price: 8,
  cadence: "/mo",
  link:
    APP_SIGN_IN_URL +
    "?continue_path=/purchase/monthly?utm_source=landing_pricing",
  // link: "https://buy.stripe.com/fZe7sYcz52DVg24bIP",
};

const yearlyPricingData = {
  label: "Yearly",
  price: 59,
  cadence: "/year",
  link:
    APP_SIGN_IN_URL +
    "?continue_path=/purchase/yearly?utm_source=landing_pricing",
  // link: "https://buy.stripe.com/5kAdRm56D4M30366os",
};

const lifetimePricingData = {
  label: "Lifetime",
  price: 120,
  cadence: "/forever",
  link:
    APP_SIGN_IN_URL +
    "?continue_path=/purchase/lifetime?utm_source=landing_pricing",
};

export const PRO_PRICING_PLANS = {
  [PricingMode.Monthly]: monthlyPricingData,
  [PricingMode.Annual]: yearlyPricingData,

  //[PricingMode.Lifetime]: lifetimePricingData,
};

const freePricingData = {
  price: 0,
  cadence: "",
  link: "https://zorbi.app/login?utm_source=pricing_page",
};

const schoolPricingData = {
  price: "X",
  cadence: "",
  link: "https://zorbi.cards/spaced-repetition-for-teachers?utm_source=pricing_page",
};

export const PRICING_TIERS: Partial<Record<PricingTier, PricingTierData>> = {
  [PricingTier.Free]: {
    label: "Free",
    text: "The world's best flashcard app",
    tier: PricingTier.Free,
    [PricingMode.Monthly]: {
      ...monthlyPricingData,
      ...freePricingData,
    },
    [PricingMode.Annual]: {
      ...yearlyPricingData,
      ...freePricingData,
    },
    [PricingMode.Lifetime]: {
      ...lifetimePricingData,
      ...freePricingData,
    },
    ctaText: "Get Started",
  },
  [PricingTier.Pro]: {
    label: "Pro",
    tier: PricingTier.Pro,
    text: "The complete and premium Zorbian experience",
    ctaText: "Upgrade now",
    ...PRO_PRICING_PLANS,
    featured: true,
  },
  [PricingTier.School]: {
    label: "Schools / Teachers",
    text: "Powerful knowledge retention insights and homework tools for teachers",
    tier: PricingTier.School,
    [PricingMode.Monthly]: {
      ...monthlyPricingData,
      ...schoolPricingData,
    },
    [PricingMode.Annual]: {
      ...yearlyPricingData,
      ...schoolPricingData,
    },
    [PricingMode.Lifetime]: {
      ...yearlyPricingData,
      ...schoolPricingData,
    },
    ctaText: "Get in Touch",
  },
  // [PricingMode.Lifetime]: {
  //   label: "Lifetime",
  //   price: 119,
  //   cadence: "one-off",
  //   subtitle: "(Yours Forever)",
  //   link: "https://buy.stripe.com/aEUaFa7eLbar5nqaEJ",
  // },
};
